module.exports = __webpack_public_path__ + "static/media/bundle_img.232c3c64.svg";